import ColorPicker from "../../colorpicker";
import { ColorPickerControlProps } from "../types";

export default function ColorPickerControl(
  props: Readonly<Omit<ColorPickerControlProps, "type">>,
) {
  const { getInputRef, ...rest } = props;
  return <ColorPicker {...rest} ref={getInputRef} />;
}
